export default __webpack_public_path__ + "static/media/KSOP.99b47cc4.png";